/**
 * @return  {string}
 */
export default function getContentFromHTMLString(htmlString) {
  if (!htmlString) return '';
  return htmlString.replaceAll(/<(?:.|\n)*?>/gm, '');
}
